import { render, staticRenderFns } from "./test.vue?vue&type=template&id=7a96532f&"
import script from "./test.vue?vue&type=script&lang=ts&"
export * from "./test.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports